import type { ContentField } from '@eliadmin/core/src/api/content-fields/content-fields-types';
import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';
import { contentFieldKey } from '@eliadmin/core/src/api/content-fields/public-content-fields';
import { getVisibleContentFields } from '@eliadmin/core/src/utils/content-fields';

// Product definitions prepared for support task 1957 in this project's administration.
// These duplicate definitions must not replace the original description/reviews.
// Keep their saved values intact in the administration; only additional tabs render here.
const descriptionIds = [3, 11];
const reviewIds = [10, 18];
const sections = [
  { id: 12, legacyId: 4, name: 'Pôdorys' },
  { id: 13, legacyId: 5, name: 'Montáž' },
  { id: 14, legacyId: 6, name: 'Doprava' },
  { id: 15, legacyId: 7, name: 'Starostlivosť' },
  { id: 16, legacyId: 8, name: 'Otázky a odpovede' },
  { id: 17, legacyId: 9, name: 'Galéria realizácií' },
] as const;

export function getProductContentLayout(product: ProductDetailData) {
  const fields = getVisibleContentFields(product);
  const select = (ids: readonly number[]) => fields.filter(field => ids.includes(field.id));
  const knownIds = new Set([
    ...descriptionIds,
    ...reviewIds,
    ...sections.flatMap(section => [section.id, section.legacyId]),
  ]);
  const contentTabs: { key: string; name: string; fields: ContentField[] }[] = [];

  for (const section of sections) {
    const values = select([section.id, section.legacyId]);
    if (!values.length) continue;
    const current = values.find(field => field.id === section.id) ?? values[0];
    contentTabs.push({
      key: contentFieldKey('products', section.id),
      name: current.name || section.name,
      fields: values,
    });
  }
  // Preserve additional project definitions rather than discarding future content.
  for (const field of fields.filter(field => !knownIds.has(field.id))) {
    contentTabs.push({
      key: contentFieldKey('products', field.id),
      name: field.name,
      fields: [field],
    });
  }

  return {
    contentTabs,
  };
}
